const fetchWrapper = {
  get: async (url) => {
    return makeRequest(url, { method: 'GET' });
  },
  post: async (url, body) => {
    return makeRequest(url, {
      method: 'POST',
      body: JSON.stringify(body)
    });
  },
  postFile: async (url, formData) => {
    return makeRequest(url, {
      method: 'POST',
      body: formData
    });
  },
  put: async (url, body) => {
    return makeRequest(url, {
      method: 'PUT',
      body: JSON.stringify(body)
    });
  },
  delete: async (url) => {
    return makeRequest(url, { method: 'DELETE' });
  }
};

async function makeRequest(url, options) {
  const token = localStorage.getItem('access_token');
  const headers = {
    ...(options.method !== 'POST' || typeof options.body !== 'object' ? { 'Content-Type': 'application/json' } : {}),
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };
  const requestOptions = {
    ...options,
    headers
  };
  const response = await fetch(addHost(url), requestOptions);
  return handleResponse(response);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (response.status === 401 || response.status === 403) {
      //return to login if it is 401 or 403
      goToLogin();
      throw new Error(data.message || 'Unauthorized');
    }
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      throw new Error(error);
    }
    return data;
  });
}

function addHost(url) {
  let baseUrl = '';

  if (window.location.href.indexOf('discountweb.infinitgrp.com') === -1 && window.location.href.indexOf('d1hebt7vsmtkrl.cloudfront.net') === -1) {
    // set uat api base url if NOT in prod environment
    baseUrl = 'https://discountportal.infinitgrp.com:8282' + url;
  } else {
    //set prod backend url
    baseUrl = 'https://discountapi.infinitgrp.com' + url;
  }
  return baseUrl;
}



function goToLogin() {
  localStorage.removeItem('access_token');
  window.location.href = '/login';
}

export default fetchWrapper;    